import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';

const Plan22 = withTableController(({ planning, state }) => (
  <Plan  planing={planning} state={state} />
));

export default Plan22;
